var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.config.title,
        visible: _vm.dialogVisible,
        width: "540px",
        "append-to-body": true,
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      this.config.source == "fd"
        ? _c(
            "div",
            { staticClass: "alert mt20" },
            [
              _c("el-alert", {
                staticClass: "cr-alert",
                attrs: {
                  type: "info",
                  description:
                    this.config.type == "edit"
                      ? "保存后，收支记账与对应合同账目记录也会同步修改！"
                      : "审核通过后，系统自动生成收支记账流水信息！",
                  "show-icon": "",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "mt15",
          attrs: {
            model: _vm.rules,
            rules: _vm.rule,
            "label-width": _vm.labelWidth + "px",
          },
        },
        [
          _vm.config.formType == "list"
            ? _c(
                "el-form-item",
                { attrs: { prop: "cid" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("选择合同： "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { size: "small", placeholder: "请选择合同" },
                      model: {
                        value: _vm.rules.cid,
                        callback: function ($$v) {
                          _vm.$set(_vm.rules, "cid", $$v)
                        },
                        expression: "rules.cid",
                      },
                    },
                    _vm._l(_vm.contractData, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.title, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "bill_cate_id" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("支出类型："),
              ]),
              _vm._v(" "),
              _c("el-cascader", {
                staticStyle: { width: "100%" },
                attrs: {
                  options: _vm.billList,
                  props: {
                    checkStrictly: true,
                    value: "id",
                    label: "name",
                    emitPath: false,
                  },
                },
                model: {
                  value: _vm.rules.bill_cate_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.rules, "bill_cate_id", $$v)
                  },
                  expression: "rules.bill_cate_id",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "num" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("支出金额(元)："),
              ]),
              _vm._v(" "),
              _c("el-input-number", {
                attrs: {
                  size: "small",
                  controls: false,
                  min: 0,
                  precision: 2,
                  placeholder: "请填写支出金额",
                },
                model: {
                  value: _vm.rules.num,
                  callback: function ($$v) {
                    _vm.$set(_vm.rules, "num", $$v)
                  },
                  expression: "rules.num",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "type_id" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("支付方式："),
              ]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { size: "small", placeholder: "请选择支付方式" },
                  model: {
                    value: _vm.rules.type_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.rules, "type_id", $$v)
                    },
                    expression: "rules.type_id",
                  },
                },
                _vm._l(_vm.paymentOptions, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "date" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("支出时间："),
              ]),
              _vm._v(" "),
              _c("el-date-picker", {
                attrs: {
                  size: "small",
                  "picker-options": "expireTimeOption",
                  type: "datetime",
                },
                model: {
                  value: _vm.rules.date,
                  callback: function ($$v) {
                    _vm.$set(_vm.rules, "date", $$v)
                  },
                  expression: "rules.date",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", [
            _c("span", { attrs: { slot: "label" }, slot: "label" }, [
              _vm._v("支出凭证："),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "avatar" },
              [
                _c(
                  "el-upload",
                  {
                    staticClass: "upload-demo mr10",
                    attrs: {
                      action: "##",
                      "show-file-list": false,
                      headers: _vm.myHeaders,
                      "http-request": _vm.uploadServerLog,
                    },
                  },
                  [
                    _vm.imageUrl
                      ? _c("img", {
                          staticClass: "img",
                          attrs: { src: _vm.imageUrl },
                        })
                      : _c("i", {
                          staticClass: "el-icon-plus avatar-uploader-icon",
                        }),
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "clew" }, [
                  _vm._v("支持jpg、jpeg、png "),
                  _c("br"),
                  _vm._v("建议734*1034 "),
                  _c("br"),
                  _vm._v("大小不超过2M"),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("备注："),
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  maxlength: "255",
                  placeholder: "请输入备注信息，最多可输入255字",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.rules.mark,
                  callback: function ($$v) {
                    _vm.$set(_vm.rules, "mark", $$v)
                  },
                  expression: "rules.mark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("public.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading, type: "primary" },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("public.ok")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }